export default class FraudHandler{

    static onLogin(profileEntity: any): void{
        this.setAuthtorization(true);
        this.setIdentity(this.getIdentity(profileEntity));
        this.setSessionID(Date.now());
    }

    static onLogout(): void{
        this.setAuthtorization(false);
        this.setIdentity(null);
        this.setSessionID(null);
    }

    public static setAuthtorization(status: boolean){
        if(status){
            (<any>window).gib.setAuthStatus((<any>window).gib.IS_AUTHORIZED);
        }
        else{
            (<any>window).gib.setAuthStatus((<any>window).gib.IS_GUEST);
        }
    }

    static setSessionID(value): void {
        (<any>window).gib.setSessionID(value || '');
	}

    static setIdentity(value): void {
        (<any>window).gib.setIdentity(value || '');
	}

    static getIdentity(profileEntity: any): string {
        var flCrmId = profileEntity?.profileData?.flCrmId;
        var ulCrmId = profileEntity?.profileData?.ulCrmId;
        if(flCrmId && ulCrmId){
            return this.normalizeValue(flCrmId.toString()) + this.normalizeValue(ulCrmId.toString());
        }
    }

    static normalizeValue(value: string): string{
        while(value.length < 10){
            value = '0' + value;
        }
        return value;
    }
}